module.exports = __webpack_public_path__ + "static/icons/icon-snow-report-e1f1fcdf99a33956756aa36c8ed06b5e.svg";